var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row fz-14"},[_c('div',{staticClass:"color-gy-8 mr-16 text-align-right",staticStyle:{"width":"60px"}},[_vm._v(_vm._s(_vm.info.label))]),_c('div',{staticClass:"color-gy-9"},[_vm._v(_vm._s(_vm.info.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }